
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Allorders from "./Orders/Allorders";
import Buyorders from "./Orders/Buyorders";
import Sellorders from "./Orders/Sellorders";
const Orders = (props) => {
const [isActive, setisActive] = useState('All');
return (
    <>
      <div className="trade-one-table-box trade-shadow-box">
        <nav className="ivo-buy-sell-tabs">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button 
            id="nav-all-tab"
            className={isActive == 'All' ? 'ivo-buy-single nav-link active' : 'ivo-buy-single nav-link'}
            onClick={()=>setisActive('All')}
            
            >ALL</button>

            <button 
            
            id="nav-buy-order-tab"
            className={isActive == 'Buy' ? 'ivo-buy-single nav-link active' : 'ivo-buy-single nav-link'}
            onClick={()=>setisActive('Buy')}
              
              
              >BUY ORDERS</button>


            <button 
           
            id="nav-sell-order-tab"
            className={isActive == 'Sell' ? 'ivo-buy-single nav-link active' : 'ivo-buy-single nav-link'}
            onClick={()=>setisActive('Sell')}
             >SELL ORDERS</button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
            {isActive == 'All' && <Allorders /> }
            {isActive == 'Buy' && <Buyorders /> }
            {isActive == 'Sell' && <Sellorders /> }
        </div>
      </div>
    </>

  );
}

export default Orders;
